<template>
  <div>
    <tablita
      :cols="columnas"
      :configuracion="configuracion_tabla"
      @cargar="cargarCertificados($event)"
      @cargar_url="cargarUrl($event)"
      @nuevo="generar($event)"
      @generar_pdf="generarPdf($event)"
      @reemitir_certificado="reemitirCertificado($event)"
      @refresh="refrescar($event)"
    ></tablita>
    <vue-confirm-dialog></vue-confirm-dialog>
    
    <!-- Modal -->
    <div class="modal fade" id="modal_certificado" data-backdrop="static" data-keyboard="false" tabindex="-1"
      role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-xl`" role="document" :style="{maxWidth: '1000px'}">
        <div class="modal-content">
          <div class="modal-header" style="background-color:#172b4d;">
            <h5 class="modal-title" style="color:#fff">
              {{ titulo_modal }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
              <span aria-hidden="true" style="color:#fff;font-size:1.2em">&times;</span>
            </button>
          </div>
          <div class="modal-body" :style="{paddingBottom: '0'}">
            <iframe :src="certificado_url" :style="{width: '100%', height: '70vh'}"></iframe>
          </div>
          <div class="modal-footer">
            <!-- <button class="btn btn-primary btn-icon" @click="confirmarCertificado">Confirmar</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Tabla from "../../components/Tabla/Tabla";
export default {
  data: () => ({
    configuracion_tabla: {
      titulo: "Listado de Certificados de Disposición",
      titulo_boton: "Generar certificado",
      clase_boton_crear: "btn-success",
      btn_nuevo: true
    },
    columnas: [
      {
        key: "correlativo",
        label: "Correlativo",
        busqueda: "",
        tipo: "string",
        path: "correlativo",
        searchable: true
      },
      {
        key: "tipo_certificado",
        label: "Tipo de certificado",
        busqueda: "",
        tipo: "select",
        path: "tipo_certificado_label",
        opciones: [
          {id: 1, name: 'Certificado Subproducto a Proceso'},
          {id: 2, name: 'Certificado Subproducto a Relleno'},
          {id: 3, name: 'Certificado Mortalidad Ensilada'},
          {id: 4, name: 'Certificado Mortalidad Entera'},
          {id: 5, name: 'Certificado Mortalidad Ensilada a Relleno'},
          {id: 6, name: 'Certificado Mortalidad No Ensilada a Relleno'},
        ],
        valor_opcion: "id",
        label_opcion: "name",
        searchable: true
      },
      {
        key: "desde",
        label: "Desde",
        busqueda: "",
        tipo: "date",
        path: "desde",
        searchable: true
      },
      {
        key: "hasta",
        label: "Hasta",
        busqueda: "",
        tipo: "date",
        path: "hasta",
        searchable: true
      },
      {
        key: "empresas_id",
        label: "Empresa(s)",
        busqueda: "",
        tipo: "string",
        path: "empresas",
      },
      {
        key: "empresas_id_principal",
        label: "Empresa principal (certificado mort. ensilada)",
        busqueda: "",
        tipo: "string",
        path: "empresa_principal.nombre",
      },
      {
        key: "dependencias_ids",
        label: "Plantas",
        busqueda: "",
        tipo: "html",
        path: "dependencias_html",
      },
      {
        key: "numero_guias",
        label: "Número(s) de guía(s)",
        busqueda: "",
        tipo: "string",
        path: "numero_guias",
      },
      {
        key: "agregar_empresa",
        label: "Agregar empresa",
        busqueda: "",
        tipo: "icono_true_false",
        icono_true: "fas fa-check",
        style_true: "color: lime",
        icono_false: "fas fa-minus",
        style_false: "color: gray",
        path: "agregar_empresa",
      },
      {
        key: "agregar_direccion",
        label: "Agregar dirección",
        busqueda: "",
        tipo: "icono_true_false",
        icono_true: "fas fa-check",
        style_true: "color: lime",
        icono_false: "fas fa-minus",
        style_false: "color: gray",
        path: "agregar_direccion",
      },
      {
        key: "agregar_destino_vertedero",
        label: "Agregar destino",
        busqueda: "",
        tipo: "icono_true_false",
        icono_true: "fas fa-check",
        style_true: "color: lime",
        icono_false: "fas fa-minus",
        style_false: "color: gray",
        path: "agregar_destino_vertedero",
      },
    ],
    botones: [
      {
        label: "Generar PDF",
        clase: "btn-danger",
        evento: "generar_pdf",
        icono: "fa fa-file-pdf"
      },
      {
        label: "Reemtitir Certificado",
        clase: "btn-primary",
        evento: "reemitir_certificado",
        icono: "fa fa-pen"
      },
    ],
    lista: [],
    links: [],
    botones_restringidos: [],
    tipos_certificados: {
      1 : 'Certificado Subproducto a Proceso',
      2 : 'Certificado Subproducto a Relleno',
      3 : 'Certificado Mortalidad Ensilada',
      4 : 'Certificado Mortalidad Entera',
      5 : 'Certificado Mortalidad Ensilada a Relleno',
      6 : 'Certificado Mortalidad No Ensilada a Relleno',
    },
    certificado_url: null,
    titulo_modal: null,
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: []
    });
    this.$emit("cargar");
  },
  methods: {
    async cargarCertificados($event) {
      this.$emit("spinner", true);
      const url = `${this.api}/certificado${$event}`;
      this.pagina_actual = url;
      this.lista = [];
      await this.axios
        .get(url, this.cabeceras_json)
        .then(res => {
          this.lista = res.data.data.data.map(item => ({...item, tipo_certificado_label: this.tipos_certificados[item.tipo_certificado]}));
          this.links = res.data.data.links;
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
            botones_restringidos: this.botones_restringidos
          });
        })
        .catch(e => {
          console.log(e);
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargarUrl(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then(res => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            this.setear_lista({ lista: this.lista, links: this.links });
          })
          .catch(e => {
            console.log(e);
          });
        this.$emit("spinner", false);
      }
    },
    generar() {
      this.$router.push(`/certificado_disposicion`);
    },

    async generarPdf({ item }) {
      const loader = this.showLoader();
      const url = `${this.api}/certificado/generar`;
      const data = {
        certificado: {
          ...item, 
          sucursal_id: item.dependencias_id ? item.dependencias_id.split(",") : [],
          empresas_id: item.tipo_certificado === 5 ? item.empresas_id.split(",") : item.empresas_id,
          fechas: [item.desde, item.hasta],
        },
      }

      await this.axios
        .post(url, data, this.cabeceras_json)
        .then(res => {
          if (!res.data.data) return;
          this.openModal(res.data.data, item.tipo_certificado);
        })
        .catch(e => {
          //alert(e);
        });
      loader.hide();
    },

    reemitirCertificado({ item }) {
      this.$router.push({name: 'certificado_disposicion', params: {correlativo: item.correlativo}});
    },

    showLoader() {
      return this.$loading.show({
        canCancel: false,
        color: "#262b63",
        backgroundColor: "#ededed",
        loader: "spinner",
      });
    },

    closeModal() {
      $("#modal_certificado").modal('hide');
      this.certificado_url = null;
      this.titulo_modal = null;
    },

    openModal(data, tipo_certificado_id) {
      this.certificado_url = `${this.api_public}/${data.filename}`;
      const tipo_certificado = this.tipos_certificados[tipo_certificado_id];
      if (tipo_certificado) this.titulo_modal = tipo_certificado;
      $("#modal_certificado").modal({ show: true });
    },

    refrescar() {
      this.columnas.forEach(columna => {
        if (columna.busqueda) columna.busqueda = "";
      });
      this.$emit("cargar");
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"])
  },
  components: {
    tablita: Tabla
  },
  computed: {
    ...mapState(["api", "api_public", "cabeceras_json"]),

    path() {
      return this.$router.currentRoute.path;
    }
  }
};
</script>
